import { render } from "./AttachRemoveDivisionSitePlanComponent.vue?vue&type=template&id=9263ecb4"
import script from "./AttachRemoveDivisionSitePlanComponent.vue?vue&type=script&lang=js"
export * from "./AttachRemoveDivisionSitePlanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__